const updates = [
  {
    date: '2026.07.28',
    title: '《沙丘：第三部》首支预告片发布',
    desc: '丹尼斯·维伦纽瓦回归执导，提莫西·查拉梅继续领衔主演，预计2027年上映。预告片全程高能，保罗·厄崔迪斯的命运将迎来最终章。',
    tag: '新片资讯',
  },
  {
    date: '2026.07.25',
    title: '平台新增"日韩剧场"分类',
    desc: '应广大用户要求，91免费正式上线日韩影视专区，涵盖热门日剧、韩剧、日本动画剧场版等优质内容，首批上线200+部。',
    tag: '平台更新',
  },
  {
    date: '2026.07.22',
    title: '《封神第二部》确认暑期档',
    desc: '乌尔善执导的封神三部曲第二部正式定档暑期，费翔、黄渤、于适等原班人马回归，续写东方神话史诗。',
    tag: '档期速报',
  },
  {
    date: '2026.07.18',
    title: '播放体验全面升级完成',
    desc: '91免费完成CDN节点扩容与技术升级，全国多地区加载速度提升40%，1080P高清视频缓冲时间缩短至毫秒级。',
    tag: '平台更新',
  },
  {
    date: '2026.07.15',
    title: '"悬疑烧脑"专题访问量破百万',
    desc: '上月推出的悬疑推理专题片单广受好评，累计访问量突破100万次，成为平台最受欢迎的主题合集之一。',
    tag: '数据快报',
  },
  {
    date: '2026.07.12',
    title: '2026下半年最值得期待的十部电影',
    desc: '编辑团队发布下半年观影指南，从好莱坞大片到独立佳作，从国产巨制到国际电影节热门，提前锁定你的观影清单。',
    tag: '编辑推荐',
  },
  {
    date: '2026.07.08',
    title: '多位独立影评人入驻平台',
    desc: '五位知名影评人正式入驻91免费，将定期发布深度影评与专题策划，为用户提供更专业的观影参考。',
    tag: '合作动态',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-4 whitespace-nowrap">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            平台快讯
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            影视资讯、平台更新、行业动态，不错过任何精彩
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 space-y-8">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[33px] md:-left-[37px] top-1 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50"></div>
                <div>
                  <div className="flex items-center gap-3 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                    <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}